
import SubBrandService from './SubBrandService';

export { default } from './SubBrandService';
export const subBrandService = new SubBrandService();
